import { FC } from 'react';

import { SectionHeading } from '@new/common/ui/SectionHeading/SectionHeading';
import { DescriptionList } from '@new/common/ui/DescriptionList/DescriptionList';
import type { TranscriptBreakdown, TranscriptFile } from '@new/features/transcripts/shared/types';

import { InstitutionDetailsEditor } from './InstitutionDetailsEditor';
import { LegacyDocumentsList } from './LegacyDocumentsList';

interface StudentTranscriptSectionProps {
  transcript: TranscriptBreakdown;
  legacyFiles: TranscriptFile[];
  onOpenTranscript?: (transcriptId: number) => void;
}

export const StudentTranscriptSection: FC<StudentTranscriptSectionProps> = ({
  transcript,
  legacyFiles,
  onOpenTranscript,
}) => (
  <section className="flex flex-col gap-3 rounded-lg border border-(--neutral-black-NB200) bg-(--neutral-white-NW1000) p-4">
    <SectionHeading title="Student Transcript" />
    <p className="m-0! truncate [font-size:var(--fs-p2)]! font-semibold text-(--neutral-black-NB1000)!">
      {transcript.institution}
    </p>

    <div className="overflow-hidden rounded-lg border border-(--neutral-black-NB100)">
      <DescriptionList>
        <DescriptionList.Row label="Official transcript requested">
          {transcript.officialTranscriptRequested ? 'Yes' : 'No'}
        </DescriptionList.Row>
        <InstitutionDetailsEditor transcript={transcript} />
      </DescriptionList>
    </div>

    {legacyFiles.length > 0 ? (
      <>
        <p className="m-0! [font-size:var(--fs-l5)]! font-semibold text-(--neutral-black-NB700)!">
          Old platform documents ({legacyFiles.length})
        </p>
        <LegacyDocumentsList
          transcriptId={transcript.id}
          files={legacyFiles}
          onOpenTranscript={onOpenTranscript}
        />
      </>
    ) : null}
  </section>
);
